import {applySnapshot, types as t,} from 'mobx-state-tree';

export const initialGeoStore = {
    geo: null,
};

export const GeoStore = t
    .model({
        geo: t.maybeNull(t.string),
    })
    .views((self) => ({
        // @ts-ignore
        currencyRate: () => self.rates[self.currency]
    }))
    .actions((self) => ({
        clearState: () => {
            applySnapshot(self, initialGeoStore);
        },
        setGeo: (geo: string|null) => {
            self.geo = geo;
        },
    }));
